import Vue from 'vue';
import './assets/scss/index.scss';
import 'element-ui/lib/theme-chalk/index.css'
import { Dialog } from 'element-ui'
import App from './App.vue';

// 按需引入UI
Vue.use(Dialog);
Vue.config.productionTip = false;

new Vue({
  render: h => h(App),
}).$mount('#app')
